import React, { Component } from 'react'
import { styles } from '../styles'
import withStyles from 'material-ui/styles/withStyles'
import withTheme from 'material-ui/styles/withTheme'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import {compose} from 'redux'
import {firebaseConnect} from 'react-redux-firebase'
import {cognitive} from '../testPool'
import {testAnswer} from './action'
import {connect} from 'react-redux'
import Card, {CardContent} from 'material-ui/Card'
import Typography  from 'material-ui/Typography';
import { LinearProgress } from 'material-ui/Progress'


function getQuestionImage(key,index) {
    return `https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/raven%2FQ%2FQ${key}-0${index}-01.jpg?alt=media`
}
function getAnswerImage(key,index, choice) {
    return `https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/raven%2FA%2FQ${key}-0${index}-0${choice+1}.jpg?alt=media`
}
function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}
class CognitiveTestContainer extends Component {
    index = 0
    test = {}
    key = ''
    choices = shuffle([1,2,3,4,5])
    constructor(props) {
        super(props)
        //console.log(this.props)
        this.test = cognitive[this.props.profile.currentIndex]
        this.key = Object.keys(this.test)[0]
        this.index = Math.floor((Math.random() * this.test[this.key])+1)
        this.choices = shuffle(this.choices)
    }
    componentWillReceiveProps() {
        //console.log('COGNITIVETESTCONTAINER GET NEW PROPS!', this.props)
        this.test = cognitive[this.props.profile.currentIndex]  
        this.key = Object.keys(this.test)[0]
        this.index = Math.floor((Math.random() * this.test[this.key])+1)
        this.choices = shuffle(this.choices)
        this.forceUpdate()
    }
    render() {
        return(
            <div>
                <Grid container style={{marginTop: "8px"}} className={this.props.classes.centerGrid} spacing={0}>
                <Card elevation={4} style={{width: '372px   '}}>
                            <CardContent style={{textAlign: 'center'}}>
                                <Typography variant="caption" >
                                แบบทดสอบส่วนที่ 1 - เชาวน์ปัญญา 

                                </Typography>
                                <Typography variant="caption" >
                                จงพิจารณาความสัมพันธ์ของอนุกรมภาพต่อไปนี้ แล้วหาภาพที่มีความสัมพันธ์ต่อเนื่องจากภาพดังกล่าว
                                </Typography>
                            </CardContent>
                        </Card><br/>
                    <Grid item >
                        <Paper>
                            <img src={getQuestionImage(this.key, this.index)} alt='#' style={{width: '360px', margin: '6px 6px 0'}} />
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container justify='center' direction='row' style={{marginTop: "8px", flexGrow: 1}} spacing={0}>
                    <Grid item style={{margin: '8px'}}>
                        <Paper 
                            onClick={()=>
                                this.props.dispatch(
                                    testAnswer(
                                        this.props.auth.uid,
                                        'cognitive',
                                        this.props.profile.currentIndex,
                                        this.key,
                                        this.choices[0],
                                        null
                                    )
                                )
                            }
                        >
                            <img src={getAnswerImage(this.key, this.index, this.choices[0])} alt='#' style={{width: '104px', margin: '6px 6px 0'}} />
                        </Paper>
                    </Grid>
                    <Grid item style={{margin: '8px'}}>
                        <Paper
                            onClick={()=>
                                this.props.dispatch(
                                    testAnswer(
                                        this.props.auth.uid,
                                        'cognitive',
                                        this.props.profile.currentIndex,
                                        this.key,
                                        this.choices[1],
                                        null
                                    )
                                )
                            }
                        >
                            <img src={getAnswerImage(this.key, this.index, this.choices[1])} alt='#' style={{width: '104px', margin: '6px 6px 0'}} />
                        </Paper>
                    </Grid>
                    <Grid item style={{margin: '8px'}}>
                        <Paper
                            onClick={()=>
                                this.props.dispatch(
                                    testAnswer(
                                        this.props.auth.uid,
                                        'cognitive',
                                        this.props.profile.currentIndex,
                                        this.key,
                                        this.choices[2],
                                        null
                                    )
                                )
                            }
                        >
                            <img src={getAnswerImage(this.key, this.index, this.choices[2])} alt='#' style={{width: '104px', margin: '6px 6px 0'}} />
                        </Paper>
                    </Grid>
                    <Grid item style={{margin: '8px'}}>
                        <Paper
                            onClick={()=>
                                this.props.dispatch(
                                    testAnswer(
                                        this.props.auth.uid,
                                        'cognitive',
                                        this.props.profile.currentIndex,
                                        this.key,
                                        this.choices[3],
                                        null
                                    )
                                )
                            }
                        >
                            <img src={getAnswerImage(this.key, this.index, this.choices[3])} alt='#' style={{width: '104px', margin: '6px 6px 0'}} />
                        </Paper>
                    </Grid>
                    <Grid item style={{margin: '8px'}}>
                        <Paper
                        //style={{marginBottom: '100px'}}
                            onClick={()=>
                                this.props.dispatch(
                                    testAnswer(
                                        this.props.auth.uid,
                                        'cognitive',
                                        this.props.profile.currentIndex,
                                        this.key,
                                        this.choices[4],
                                        null
                                    )
                                )
                            }
                        >
                            <img src={getAnswerImage(this.key, this.index, this.choices[4])} alt='#' style={{width: '104px', margin: '6px 6px 0'}} />
                        </Paper>
                    </Grid>
                    
                </Grid>
                <Grid container style={{marginTop: "8px"}} className={this.props.classes.centerGrid} spacing={0}>
                    <Grid item style={{margin: '8px',width: '100%'}} >
                        <center>
                        <Typography style={{textAlign:'center'}}>
                            {`${this.props.profile.currentIndex+1}/15`}
                        </Typography>
                        </center>
                        <center><LinearProgress style={{width: '350px', marginBottom: '100px'}} color="secondary" variant="determinate" value={((this.props.profile.currentIndex+1)/15)*100} /></center>
                    </Grid>
                </Grid>
                
            </div>
        )
    }
}

export default compose(firebaseConnect(),withTheme(),withStyles(styles),
    connect(({firebase: {auth}}) => ({auth})))(CognitiveTestContainer)


// WEBPACK FOOTER //
// ./src/test/CognitiveTestContainer.js